<template>
    <app-layout title="Settings">
        <page-header>
            <template #title>Settings - Users</template>

            <template #actions>
                <jet-button type="button" class="h-7 leading-none" @click="showInviteModal = true" >
                    Invite User
                </jet-button>
            </template>

        </page-header>

        <settings-navigation />

        <div class="px-8 mb-4 xl:flex">
            <div class="rounded-t overflow-hidden border border-b-0 w-3/4">
                <table class="table w-full">
                    <thead>
                        <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">Email</th>
                            <th class="text-left">Role(s)</th>
                            <th class="text-left">Enable</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in users" :key="user.id">
                            <td>{{ user.name }}</td>
                            <td>{{ user.email }}</td>
                            <td>
                                <span v-for="(role, index) in sortRoles(user.roles)" :key="role" class="capitalize" >{{ role.name }}{{ index == (user.roles.length - 1) ? '' : ', ' }}</span>
                            </td>
                            <td>{{ user.enabled ? 'YES' : 'NO' }}</td>
                            <td class="text-right">
                                <jet-secondary-button class="mx-4" @click="editUser(user)">
                                    Edit
                                </jet-secondary-button>

                                <jet-danger-button class="mx-4" @click="deleteUser(user)">
                                    Delete
                                </jet-danger-button>
                            </td>
                        </tr>
                        <tr v-if="!users.length">
                            <td colspan="3" class="text-center py-8">No Users Defined</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Invite User -->
            <user-form
                :showModal="showInviteModal"
                :roles="roles"
                :locations="locations"
                @close="showInviteModal = false"
                @submitted="showInviteModal = false"
            />

            <!-- Edit User -->
            <user-form
                :user="selectedUser"
                :showModal="showEditModal"
                :roles="roles"
                :locations="locations"
                @close="showEditModal = false, selectedUser = null"
                @submitted="showEditModal = false"
            />

            <!-- Delete User -->
            <jet-confirmation-modal :show="showDeleteUser" @close="cancelDeleteUser">
                <template #title>
                    Delete User
                </template>

                <template #content>
                    Are you sure you would like to delete <strong>{{ form.name }}</strong>?
                </template>

                <template #footer>
                    <jet-danger-button @click="handleDeleteUser">
                        Yes
                    </jet-danger-button>

                    <jet-tertiary-button class="ml-2" @click="cancelDeleteUser">
                        No
                    </jet-tertiary-button>
                </template>
            </jet-confirmation-modal>

        </div>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import SettingsNavigation from '@/Pages/Settings/Partials/SettingsNavigation';
import UserForm from '@/Pages/Settings/Partials/UserForm'

export default {
    setup() {
        const form = useForm({
            id: null,
            name: null,
            email: null,
            roles: [],
            enabled: 1,
            location_id: '',
        });

        return { form }

    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetDangerButton,
        JetConfirmationModal,
        JetSecondaryButton,
        JetTertiaryButton,
        SettingsNavigation,
        UserForm,
    },

    props: ['users', 'roles', 'locations'],

    data() {
        return {
            showInviteModal: false,
            showEditModal: false,
            showDeleteUser: false,
            selectedUser: null,
        }
    },

    methods: {
        sortRoles(roles) {
            let sorted = roles.sort(function(a,b) {
                if(a.name < b.name) return -1;
                else if (a.name > b.name) return 1;
                return 0;
            });

            return sorted;
        },

        editUser (user) {
            this.selectedUser = user;
            this.showEditModal = true;

        },

        deleteUser(user) {
            this.form.id = user.id;
            this.form.name = user.name;
            this.form.email = user.email;
            this.showDeleteUser = true;
        },

        cancelDeleteUser() {
            this.form.reset();
            this.showDeleteUser = false;
        },

        handleDeleteUser() {
            this.form.delete(this.route('settings.users.destroy', this.form.id), {
                onSuccess: () => {
                    this.form.reset();
                    this.showDeleteUser = false;
                }
            });
        },
    },
}
</script>

<style scoped>


</style>
